(function () {
  'use strict';

  angular.module('web2print').factory('Translation', Translation);

  Translation.inject = ['$filter', '$rootScope'];

  function Translation ($filter, $q, $rootScope) {
    const $translate = $filter('translate');

    /**
         * Constructor creating an Translation Entity.
         * @constructor
         */
    function TranslationEntity (keys, parameters, separator) {
      this.keys = keys; // String or array of Strings
      this.parameters = parameters;
      this.separator = separator === null && separator === undefined ? ' ' : separator;
      this.getTranslation = function () {
        const translations = $translate(this.keys, this.parameters);
        if (typeof translations === 'string') {
          return translations;
        }
        return Object.keys(translations).map(function (k) { return translations[k]; }).join(this.separator);
      };
      // TODO: readable only
      this.value = this.getTranslation();

      // Update if any changes have been made, e.g. language change
      $rootScope.$on('$translateChangeSuccess', function () {
        this.value = this.getTranslation();
      }.bind(this));
    }

    return {
      /**
             * Creates an translation object that will keep up with language change  in the translation module
             * E.g. when the language changes the value will be updated to that language.
             * @param {string|string[]} keys I18N keys
             * @param {Object} parameters Interpolate parameters
             * @param {string} [ ] separator Separator when multiple I18N keys are concatenated (default: single space)
             * @return {Object} TranslationEntity
             */
      translate: function (keys, parameters, separator) {
        return new TranslationEntity(keys, parameters, separator);
      }
    };
  }
})();
